import { RouteObject } from "react-router-dom";

import ErrorBoundary from "src/components/Errors/ErrorBoundary.tsx";
import FlaminemReporting from "src/web-components/FlaminemReporting.tsx";

export const reportingRoutes: RouteObject[] = [
  {
    path: "/reporting/*",
    Component: FlaminemReporting,
    ErrorBoundary: ErrorBoundary,
  },
];
